import { HIDE_BOOKING_DIALOG } from "./types";

const hideBookingDialog = () => ({
  type: HIDE_BOOKING_DIALOG,
});

export default hideBookingDialog;
